﻿import React, { useState, useEffect } from 'react';
import { FtirAnalysisType, ModalMessageType, FtirOutputFileFormatType } from '../models/enums';
import { FtirAnalysisData } from '../models/ftir-analysis-data';
import { CrudFunctions } from '../utilities/crud-functions';
import { ToastProps } from '../models/toast-props';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { Document } from '../models/document';
import { SpectralFileDataUpsertRequest } from '../models/spectral-file-data-upsert-request';

import { Toast } from 'devextreme-react/toast';
import { Button } from 'devextreme-react/button';
import { TextBox } from 'devextreme-react/text-box';
import { SelectBox } from 'devextreme-react/select-box';
import HtmlEditor from 'devextreme-react/html-editor';
import { LoadPanel } from 'devextreme-react/load-panel';

export interface Props {
    benchSheetId: string;
    ftirStandardTypeOptions: any[];
    ftirAnalysisType: FtirAnalysisType;
    onClose?: () => void;
}

export default function FtirStandardsComponent(props: Props) {
    const [analysisData, setAnalysisData] =
        useState<FtirAnalysisData>();

    const [htmlInformationString, setHtmlInformationString] =
        useState<string>();

    const [outputFile, setOutputFile] =
        useState<Document>();

    const [outputFileFormat, setOutputFileFormat] =
        useState<FtirOutputFileFormatType>();

    const [loadPanelVisible, setLoadPanelVisible] =
        useState<boolean>(false)

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        //getAllData();
    }, [props.benchSheetId]);

    return (
        <div className="pw-form-section">
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">
                    <div className="pw-margin-right-1 pw-readonly-label">Saving may take a minute or longer</div>

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height='1.8rem'
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height='1.8rem'
                        onClick={onCloseClick} />
                </div>
            </div>

            <div id="mainSection">
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-40">
                        <label className="pw-form-unit-label">Standards Manufacturer</label>
                        <SelectBox id="ftirStandardTypeId" className="selectbox"
                            valueExpr="value" displayExpr="label"
                            showClearButton={false}
                            dataSource={props.ftirStandardTypeOptions}
                            onValueChanged={onFtirStandardTypeValueChanged}
                            value={analysisData?.ftirStandardTypeId ?? 1} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-20">
                        <label className="textbox-label">Catalog #</label>
                        <TextBox id="catalogNumber"
                            className="textbox"
                            onValueChanged={onValueChanged}
                            showClearButton={true}
                            placeholder="catalog number" value={analysisData && analysisData.catalogNumber ?
                                analysisData.catalogNumber : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-20">
                        <label className="textbox-label">Lot #</label>
                        <TextBox id="lotNumber"
                            className="textbox"
                            onValueChanged={onValueChanged}
                            showClearButton={true}
                            placeholder="lot number" value={analysisData && analysisData.lotNumber ?
                                analysisData.lotNumber : undefined} />
                    </div>
                </div>

                {props.ftirAnalysisType === FtirAnalysisType.Recrystalized &&
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-20">
                            <label className="textbox-label">Solvent</label>
                            <TextBox id="solvent"
                                className="textbox"
                                onValueChanged={onValueChanged}
                                showClearButton={true}
                                placeholder="solvent" value={analysisData && analysisData.solvent ?
                                    analysisData.solvent : undefined} />
                        </div>
                        <div className="pw-form-unit pw-comp-20">
                            <label className="textbox-label">Chemical Name</label>
                            <TextBox id="chemicalName"
                                className="textbox"
                                onValueChanged={onValueChanged}
                                showClearButton={true}
                                placeholder="chemical name" value={analysisData && analysisData.chemicalName ?
                                    analysisData.chemicalName : undefined} />
                        </div>
                        <div className="pw-comp-5 pw-row-button-08">
                            <Button id="solventFind" icon="find" onClick={onSolventFind} />
                        </div>
                    </div>
                }

                <div className="pw-comp-row pw-margin-bottom-1">
                    <div>
                        <Button type='success' icon="upload" text="Upload CSV File"
                            className="pw-margin-left-05"
                            height='1.8rem' width='10rem' hint="upload .csv or text file"
                            onClick={uploadCsvFile} />
                    </div>
                    <div>
                        <Button type='success' icon="upload" text="Upload SPA File"
                            className="pw-margin-left-05"
                            height='1.8rem' width='10rem' hint="upload .spa file"
                            onClick={uploadSpaFile} />
                    </div>
                </div>
            </div>


            {htmlInformationString &&
                <div className="pw-comp-row">
                    <HtmlEditor height="20rem" readOnly={true}
                        value={htmlInformationString ?
                            htmlInformationString : undefined} />
                </div>
            }

            <input type="file"
                id="fileInputElement"
                accept=".csv,.spa,.txt"
                className="file-picker-input"
                value=""
                onChange={onFileLoaderChange} />

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            <LoadPanel
                shadingColor="rgba(0, 0, 0, 0.4)"
                position={{ of: '#mainSection' }}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false} />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function uploadCsvFile() {
        setOutputFileFormat(FtirOutputFileFormatType.CSV);

        fileLoaderClick();
    }

    function uploadSpaFile() {
        setOutputFileFormat(FtirOutputFileFormatType.SPA);

        fileLoaderClick();
    }

    function fileLoaderClick() {
        const fileElem = document.getElementById("fileInputElement") as HTMLInputElement;

        if (fileElem)
            fileElem.click();
    }

    async function onSaveClick() {
        let request: SpectralFileDataUpsertRequest = {
            ftirAnalysisData: analysisData,
            uploadFile: outputFile,
            ftirAnalysisType: props.ftirAnalysisType
        };

        request.ftirAnalysisData.benchSheetId = props.benchSheetId;
        request.ftirAnalysisData.ftirAnalysisType = props.ftirAnalysisType;
        showLoadPanel();

        if (analysisData) {
            await updateSpectralFileData(request)
                .then((data) => {
                    hideLoadPanel();
                    showToast("Spectral Data Updated Successfully", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Analysis Data");
                });
        }
    }

    function onCloseClick() {
        if (props.onClose)
            props.onClose();
    }

    function onSolventFind(e: any) {

    }

    function onFtirStandardTypeValueChanged(e: any) {
        setAnalysisData({ ...analysisData, ftirStandardTypeId: e.value });
    }

    function onValueChanged(e: any) {
        const caller = e.element.id;

        setAnalysisData({ ...analysisData, [caller]: e.value });
    }

    async function parseOutputFile(spaFile: Document) {
        if (outputFileFormat)
            return await CrudFunctions.postData(`benchsheets/parseftitoutputfile/${outputFileFormat}`, spaFile)
    }

    async function updateSpectralFileData(editedAnalysisData: FtirAnalysisData) {
        if (outputFileFormat)
            return await CrudFunctions.putData(`benchsheets/spectralfiledata/${outputFileFormat}`, editedAnalysisData)
    }

    async function onSpaDocumentLoaded(document: Document) {
        setOutputFile(document);

        await parseOutputFile(document)
            .then((data) => {
                showToast("File Parsed Successfully", "success");

                if (data)
                    setHtmlInformationString(data.value);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Parsing .SPA File");
            });
    }

    async function onFileLoaderChange(e: any) {
        let files = e.target.files;

        if (files && files.length > 0) {
            let file = files[0];

            let doc: Document = {
                name: file.name,
                kbSize: file.size,
                mimeTypeString: file.type
            };

            var reader = new FileReader();

            reader.onload = (event: any) => readFile(doc, event)
                .then((doc) => {
                    onSpaDocumentLoaded(doc);
                });

            reader.readAsBinaryString(file);
        }
    }

    async function readFile(doc: Document, event: any): Promise<any> {
        if (event && event.target && event.target.result) {
            let binaryString = event.target.result;
            let documentData = btoa(binaryString);

            doc.base64Blob = documentData;
            return doc;
        }
    }

    function showLoadPanel() {
        setLoadPanelVisible(true);
    }

    function hideLoadPanel() {
        setLoadPanelVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}

